import React, { useState } from "react";
import "./CVRQueryForm.css";
import Modal from "react-modal";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import logo from "../assets/images/cvr.png";

interface CVRQueryFormProps {
  isOpen: boolean;
  onRequestClose: () => void;
  cvrTopic: string;
  setCvrTopic: (topic: string) => void;
  handleCvrQuery: (includeMapDetails: boolean) => void;
}

const CVRQueryForm: React.FC<CVRQueryFormProps> = ({
  isOpen,
  onRequestClose,
  cvrTopic,
  setCvrTopic,
  handleCvrQuery,
}) => {
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "50%",
      height: "65%",
      borderRadius: "10px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
    },
  };

  const [includeMapDetails, setIncludeMapDetails] = useState<boolean | null>(
    null
  );
  const options = [
    { name: "Do not include further details", code: false },
    { name: "Include map details", code: true },
  ];

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onRequestClose}
      contentLabel="CVR Query Modal"
    >
      <div className="cvr-query-modal-content">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginBottom: "-5px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ width: "150px", marginRight: "10px" }}
          />
        </div>
        <label className="cvr-query-label">
          Ask about relevant CVR data:
        </label>
        <div className="card cvr-include-map-details">
          <Dropdown
            value={options.find((option) => option.code === includeMapDetails)}
            onChange={(e) => setIncludeMapDetails(e.value.code)}
            options={options}
            optionLabel="name"
            placeholder="Include Map Details?"
            className=""
          />
        </div>
        <textarea
          className="cvr-query-modal-input"
          placeholder="Enter topic here..."
          spellCheck="false"
          value={cvrTopic}
          onChange={(e) => setCvrTopic(e.target.value)}
          rows={5}
        />
        <div className="cvr-buttons">
          <button
            className="modal-button-left"
            onClick={() => handleCvrQuery(includeMapDetails ?? false)}
          >
            Query
          </button>
          <button className="modal-button-left" onClick={onRequestClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CVRQueryForm;
